import React, { PropsWithChildren } from "react";
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { getConfig } from "./config";

interface Auth0ProviderWithConfigProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithConfig = ({
  children,
}: PropsWithChildren<Auth0ProviderWithConfigProps>): JSX.Element | null => {
  const navigate = useNavigate();
  const config = getConfig();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || "/app", { replace: true });
  };

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: `${window.location.origin}/loginCallback`,
        scope: "openid profile email offline_access",
        ...(config.audience ? { audience: config.audience } : {}),
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
